import { render, staticRenderFns } from "./NewGoodsItem.vue?vue&type=template&id=056ef11e&scoped=true&"
import script from "./NewGoodsItem.vue?vue&type=script&lang=js&"
export * from "./NewGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./NewGoodsItem.vue?vue&type=style&index=0&id=056ef11e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ef11e",
  null
  
)

export default component.exports